import { useEffect, useState } from "react";
import { Pencil, Plus, UserCheck } from "lucide-react";
import { toast } from "sonner";
import usePoll from "@/hooks/usePoll";
import { api } from "@/lib/api";
import { Empty, Money, PageHeader } from "@/components/common";
import { FormModal } from "@/pages/Purchases";

export default function Sections() {
  const inv = usePoll("/inventory/summary", null, 30000);
  const [workers, setWorkers] = useState([]);
  const [edit, setEdit] = useState(null);
  useEffect(() => { api.get("/users/workers").then((r) => setWorkers(r.data)); }, []);
  const rows = inv.data?.sections || [];
  const init = edit?.id ? { ...edit, default_price: String(edit.default_price), worker_id: edit.worker_id || "", active: edit.active !== false ? "1" : "0", location: edit.location || "", notes: edit.notes || "" }
    : { name: "", code: "", location: "", default_price: "", worker_id: "", active: "1", notes: "" };
  const submit = async (f) => {
    const b = { name: f.name, code: f.code, location: f.location || null, default_price: Number(f.default_price || 0), worker_id: f.worker_id || null, active: f.active === "1", notes: f.notes || null };
    if (edit?.id) await api.put(`/sections/${edit.id}`, b); else await api.post("/sections", b);
    toast.success("تم حفظ القسم – لا يؤثر تغيير السعر على المبيعات السابقة"); inv.reload();
  };
  return (
    <div>
      <PageHeader title="أقسام الحظيرة" subtitle="تقسيم الحظيرة حسب سعر البيع، مع عامل مسؤول عن كل قسم">
        <button className="k-btn-primary" onClick={() => setEdit({})} data-testid="add-section-button"><Plus className="w-5 h-5" /> قسم جديد</button>
      </PageHeader>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {rows.map((s) => {
          const pct = s.allocated > 0 ? Math.min(100, Math.round((s.sold * 100) / s.allocated)) : 0;
          return (
            <div key={s.id} className={`k-card p-5 fade-up ${s.active === false ? "opacity-60" : ""}`} data-testid={`section-card-${s.code}`}>
              <div className="flex items-start justify-between">
                <div><div className="text-3xl font-black font-display text-[#1A4D2E]">{s.code}</div><div className="font-bold">{s.name}</div><div className="text-xs text-slate-500">{s.location}</div></div>
                <button className="k-btn-outline k-btn-sm" onClick={() => setEdit(s)} data-testid={`edit-section-${s.code}`}><Pencil className="w-4 h-4" /></button>
              </div>
              <div className="mt-3 text-2xl"><Money v={s.default_price} /></div>
              <div className="text-sm mt-2 flex items-center gap-1"><UserCheck className="w-4 h-4" /> {s.worker_name || <span className="text-amber-700 font-bold">بدون عامل مسؤول</span>}</div>
              {s.active === false && <div className="text-xs font-bold text-rose-700 mt-1">القسم معطل</div>}
              <div className="mt-4 h-2 rounded-full bg-[#F1EBDF] overflow-hidden"><div className="h-full bg-[#D97706]" style={{ width: `${pct}%` }} /></div>
              <div className="grid grid-cols-4 gap-2 text-center text-xs mt-3">
                <div><div className="num text-base">{s.allocated}</div>موزعة</div><div><div className="num text-base">{s.sold}</div>مباعة</div>
                <div><div className="num text-base">{s.available}</div>متاحة</div><div><div className="num text-base">{s.exited}</div>خرجت</div>
              </div>
            </div>
          );
        })}
      </div>
      {inv.data && !rows.length && <Empty text="لا توجد أقسام بعد – أنشئ القسم الأول" />}
      {edit && <FormModal open onOpenChange={(o) => !o && setEdit(null)} title={edit.id ? `تعديل القسم ${edit.code}` : "قسم جديد"} initial={init} submit={submit} testid="section-form"
        fields={[["name", "اسم القسم *"], ["code", "الرمز (مثل A) *"], ["location", "الموقع داخل الحظيرة"], ["default_price", "السعر الافتراضي (دج) *", "number"],
          ["worker_id", "العامل المسؤول", "select", <><option value="">— بدون —</option>{workers.map((w) => <option key={w.id} value={w.id}>{w.full_name}</option>)}</>],
          ["active", "الحالة", "select", <><option value="1">نشط</option><option value="0">معطل</option></>], ["notes", "ملاحظات"]]} />}
    </div>
  );
}
